import { lazy, Suspense } from 'react';
import { Flex, Spinner } from '@kognitos/lattice';
import type { IAutomationEditorProps } from './AutomationEditor';

export const importAutomationEditor = () =>
  import('./AutomationEditor').then(m => ({
    default: m.AutomationEditor,
  }));

// Lazy load the AutomationEditor implementation for better code splitting
const AutomationEditorLazy = lazy(importAutomationEditor);

/**
 * Lazy-loaded AutomationEditor component with loading fallback.
 *
 * This wrapper provides code splitting for the heavy AutomationEditor component,
 * showing a centered spinner while the component loads.
 *
 * NOTE: a route that is ALREADY lazy does not need this — see
 * pages/workspace/draft/edit/Page.tsx, which imports AutomationEditor directly
 * because nesting a second `lazy()` inside a lazy route made every first
 * client-side navigation paint this fallback for half a second.
 */
export function LazyAutomationEditor(props: IAutomationEditorProps) {
  return (
    <Suspense
      fallback={
        <Flex
          justify="center"
          align="center"
          width="full"
          height="full"
          data-testid="automation-editor-suspense-fallback"
        >
          <Spinner size="xl" />
        </Flex>
      }
    >
      <AutomationEditorLazy {...props} />
    </Suspense>
  );
}

export default LazyAutomationEditor;
